export const TRANSLATIONS = {
  en: {
    // General
    appTitle: 'TerraGuessr',
    continue: 'Continue',
    confirm: 'Confirm',
    cancel: 'Cancel',
    createRoom: 'Create a room',
    or: 'or',
    join: 'Join',
    roomsCodePlaceholder: 'Room code (6 digits)',
    inviteDiscordBot: 'Invite the Discord bot',
    quit: 'Quit',
    close: 'Close',
    openChat: 'Open chat',
    closeChat: 'Close chat',
    connecting: 'Connecting…',
    room: 'Room',
    scores: 'Scores',
    announcements: 'Announcements',
    chat: 'Chat',
    send: 'Send',
    chat_placeholder: 'Message...',
    logoAlt: 'Logo',
    switchToFrench: 'Switch to French',
    switchToEnglish: 'Switch to English',
    // Landing
    landing_subtitle: "Guess the author of the messages, challenge your friends, and climb the leaderboard.",
    landing_placeholder: 'Enter a nickname',
    landing_error_required: 'Nickname is required (max 16 characters).',
    landing_toRooms_title: 'Enter a nickname to continue',
    landing_toRooms_btn: 'See rooms',
    // Home
    home_welcome: 'Welcome to TerraGuessr',
    home_choose_nickname: 'Choose a nickname to start',
    home_nickname_placeholder: 'Nickname',
    // ServerList
    servers_join_or_create: 'Join or create a room',
    servers_launch_with_bot: 'Start a game with the Discord bot',
    servers_step_invite: 'Invite the bot to your Discord server.',
    servers_step_command: 'In the right channel, run the command below.',
    servers_copy_title: 'Copy then paste this command in Discord',
    servers_edit_nickname: 'Edit nickname',
    // Game header
    round: 'Round',
    phase: 'Phase',
  phase_thinking: 'Thinking',
  phase_result: 'Result',
  phase_transition: 'Transition',
  phase_ended: 'Ended',
    settings: 'Settings',
    importBeforeStart: 'Import dump.csv before starting',
    importOk: '✓ Import OK',
    roundsLabel: 'Rounds',
    messagesPerRoundLabel: 'Messages/round',
    minMessageLengthLabel: 'Pav-o-meter',
    thinkingTimeLabel: 'Thinking time (s/message)',
    onlyGifs: 'GIFs only',
    beta: 'Beta',
    messagesInARow: 'Messages in a row',
    configureThenStart: 'Configure the settings then use the bottom button to start',
  // Modes / Tabs
  modes: 'Modes',
  configuration: 'Configuration',
  selectModeFirst: 'Select a mode first',
  mode_classic_name: 'Classic',
  mode_classic_desc: 'Guess the author from gradually revealed messages.',
  mode_mashup_name: 'Whose sound?',
  mode_mashup_desc: 'Guess who made the audio clip.',
  mode_chrono_name: 'Chrono',
  mode_chrono_desc: 'Guess when a message was posted, on a timeline.',
  mode_blindtest_name: 'Blind Test',
  mode_blindtest_desc: 'Guess which mashup the clip is from.',
  source_messages: 'Messages',
  source_mashups: 'Mashups',
  source_creation: 'Creation',
  mode_atelier_name: 'Art Battle',
  mode_atelier_desc: 'Draw the theme, then everyone rates blind. Reveal last to first.',
  atelierPrompt: 'Draw', atelierSubmit: 'Submit my drawing', atelierWaitOthers: 'Waiting for others...',
  atelierRateHint: 'Rate the creations', atelierNoOther: 'Nothing to rate.', atelierResults: 'Results',
  atelierReadyHint: 'Ready to create!', atelierCreateTime: 'Draw time', atelierRateTime: 'Rating time',
  atelierConfigHint: 'Everyone draws the theme, then rates blind. Reveal from last to first.',
  mode_studio_name: 'Studio',
  mode_studio_desc: 'Recreate the mashup you are given: record layered tracks, then everyone rates blind.',
  studioPrompt: 'Compose', studioSubmit: 'Submit my creation',
  studioHint: 'Put on headphones, listen to the mashup, then stack your tracks.',
  studioRecreate: 'Recreate this mashup', studioReference: 'Reference (the mashup)',
  studioAddTrack: 'New track', studioCountin: '… get ready (1st pass)', studioRecording: '🔴 Recording…',
  studioSubmitted: 'Creation sent, waiting for the others...', studioMicDenied: 'Microphone denied or unavailable.',
  studioDecodeErr: 'Failed to decode the take.', studioRateTitle: 'Rate the creations', studioCreation: 'Creation',
  studioResults: 'Results', studioLoopLabel: 'Loop length', studioCreateLabel: 'Creation time',
  studioRateLabel: 'Rating time', studioSameMashup: 'Same mashup for everyone',
  studioMetro: 'Metronome', studioPlayAll: 'Play all', play: 'Play',
  studioEmptyHint: 'Place the cursor, then ⏺ to record',
  studioBadExtract: 'This extract does not suit me',
  studioRecTrack: 'Record a track', studioStopRec: 'Stop recording',
  studioMonitor: 'Listen', studioMonMashup: 'Mashup', studioMonTracks: 'Tracks', studioMonNone: 'Nothing',
  studioRecord: 'Record', studioPreview: 'Play', studioStop: 'Stop', studioUndo: 'Undo',
  studioBusy: '...', studioFull: 'Max reached', studioLayer: 'Layer', studioVoices: 'voices',
  studioCountin: 'Get ready...', studioRecording: '🔴 Sing!',
  studioMicErr: 'Mic unavailable (allow the microphone).',
  studioNoSupport: 'Your browser does not support audio recording.',
  studioConfigHint: 'Everyone composes a track (beat + voices), then rates blind. Reveal from last to first.',
  studioCreateTime: 'Studio time',
  mode_discussion_name: 'Bluff',
  mode_discussion_desc: 'A real message is shown. Invent a fake reply, then find the true one among the bluffs.',
  discussionContext: 'The conversation', discussionWrite: 'Your fake reply', discussionWritePlaceholder: 'Invent their reply...',
  discussionReplyAs: 'Reply as', discussionWhichReal: 'Which is the real reply from',
  discussionSubmitLie: 'Submit my bluff', discussionWaitLies: 'Waiting for the others...',
  discussionVoteHint: 'Which is the REAL reply?', discussionVoted: 'Voted!', discussionYourLie: 'your bluff',
  discussionReal: 'Real reply', discussionResults: 'Results', discussionFound: 'found it', discussionFooled: 'fooled',
  discussionWriteTime: 'Writing time', discussionVoteTime: 'Voting time',
  discussionConfigHint: 'Everyone writes a fake reply, then must find the real one. Find it: +2. Fool someone: +1.',
  chronoThinkLabel: 'Time to guess',
  chronoDragHint: 'Drag the cursor to place your date, then lock in',
  chronoWaiting: 'Waiting for the other players...',
  mode_firstgif_name: 'First GIF',
  mode_firstgif_desc: 'When did this author first send this GIF? Place it on the timeline.',
  mode_events_name: 'Timeline',
  mode_events_desc: 'Five notable messages from one author - put them back in chronological order.',
  eventsHint: 'Order from oldest (top) to most recent (bottom)',
  eventsOldest: 'Oldest', eventsNewest: 'Most recent',
  eventsSubmit: 'Lock my order', eventsWaiting: 'Waiting for the others...',
  eventsResults: 'Correct order', eventsYourScore: 'Your score',
  eventsTime: 'Ordering time',
  eventsConfigHint: 'Detects notable messages (good/bad news) from one author; players reorder them chronologically.',
  mode_coverDraw_name: 'Cover', mode_coverDraw_desc: 'Draw a cover for the mashup you land on; then everyone guesses.',
  coverSpinning: 'Spinning...', coverYourMashup: 'Your mashup', coverDrawFor: 'Draw the cover for',
  coverSubmit: 'Submit my cover', coverSubmitted: 'Cover submitted, waiting for the others...',
  coverYours: 'Your cover! The others are guessing...', coverGuessed: 'Answer sent',
  coverGuessPlaceholder: 'Which mashup? (search)', coverUpvote: 'Nice cover', coverOfficial: 'Official cover!',
  coverBy: 'By', coverFound: 'Found by', coverNobody: 'Nobody found it', coverDrawTime: 'Drawing time',
  share: 'Share', linkCopied: 'Copied!', shareHint: 'Scan, or click to copy the link',
  privacy: 'Privacy', terms: 'Terms',
  tabProfile: 'Profile',
  settingsTitle: 'Settings', languageLabel: 'Language',
  eloAdminTitle: 'ELO management', eloAdminSearch: 'Search a player...', eloAdminSet: 'OK',
  mode_whoisit_name: "Who is it?",
  mode_whoisit_desc: 'A first name is hidden in a message and the authors are anonymized. Guess the name.',
  whoHint: 'Who is the hidden name?', whoPlaceholder: 'Type the first name...',
  whoSubmit: 'Guess', whoWaiting: 'Waiting for the others...',
  whoAnswer: 'It was', whoCorrect: 'Correct!', whoWrong: 'Wrong',
  whoTime: 'Guessing time',
  whoConfigHint: 'A first name is censored, authors anonymized. Close spelling still counts.',
  whoManageNames: 'Manage names', whoNamesHint: 'One name per line. Auto-detected names are pre-filled: add or remove as needed.',
  whoNamesCount: 'names', whoNamesReset: 'Reset (detected)', save: 'Save',
  chronoLock: 'Lock in',
  chronoActualDate: 'Actual date',
  chronoYourGuess: 'Your guess',
  mashupTitleHint: 'Which mashup is it?',
  mashupSearchPlaceholder: 'Search a mashup...',
  mashupNoResult: 'No result',
  mashupWaitReveal: 'Waiting for the reveal...',
  blindtestAttemptsLabel: 'Attempts',
  drawEnableLabel: 'Shared drawing zone',
  drawTab: 'Draw',
  drawPen: 'Pen', drawEraser: 'Eraser', drawColor: 'Color',
  drawExport: 'Export', drawCopied: 'Copied!', drawCopyErr: 'Failed',
  drawTitle: 'The collective masterpiece',
  drawClearVote: 'Clear', drawClearVoteHint: 'Vote to clear (51%)',
  adminTab: 'Admin', macTitle: 'Mode access', macAdmins: 'Admins', macPlayers: 'Players',
  macHint: 'You (owner) always have every mode. Updates in real time.',
  clipDurationLabel: 'Clip length',
  extractionPeriodLabel: 'Clip position',
  extractionStart: 'Start',
  extractionMiddle: 'Middle',
  extractionRandom: 'Random',
  allowedAuthorsLabel: 'Allowed authors',
  volumeLabel: 'Volume',
  listenAndGuess: 'Play',
  mashupLoadError: 'Failed to load authors (Terrashup unavailable).',
  mashupAuthorsHint: 'Select at least 2 authors to start.',
  mashupReady: 'Ready to play!',
  mashupBy: 'by',
  mashupStarting: 'Starting...',
  // Config split / importing
  messagesSource: 'Messages source',
  importFromFile: 'Import from file',
  dragOrClick: 'Drag a file here or click to select',
  remove: 'Remove',
  replace: 'Replace',
  or: 'OR',
  discordConnect: 'Connect Discord',
  discordNotConnected: 'No Discord source connected',
  comingSoon: 'Coming soon',
  discordConnected: 'Connected as',
  selectChannels: 'Select channels',
  selectGuilds: 'Select servers',
  noGuildsFound: 'No servers found',
  guildOwner: 'Owner',
  selectMessagesDiscord: 'Select messages from Discord',
  channelsFor: 'Channels for',
  selected: 'selected',
  refresh: 'Refresh',
  noChannels: 'No channels',
  channelSelectionHint: 'Select up to 5 text channels across all servers.',
  selectedChannels: 'Selected channels',
  selectAuthors: 'Select authors',
  authorsFromChannels: 'Authors found in selected channels',
  noAuthorsFound: 'No authors found',
  authorSelectionHint: 'Select between 2 and 10 authors.',
  next: 'Next',
  back: 'Back',
  noAccessibleServers: 'No accessible servers',
  noAccessServer: 'Bot cannot access this server',
  emptyServerNoChannels: 'No readable text channels found',
  inviteBot: 'Invite bot',
  inviteBotExplain: 'Invite the bot to the server, then reopen this dialog.',
  parameters: 'Parameters',
    // Game / Lobby CTA & misc
    startGame: 'Start game',
    importCsvHint: 'Import a CSV to be able to start',
    datasetReady: 'Dataset ready',
    pleaseImportCsvBeforeStart: 'Please import a CSV before starting.',
    protectedLink: 'Access via protected link',
    confirmQuit: 'Quit the game?',
    // GuessZone
    chooseAuthorHint: "Choose the author (list updates based on imported messages)",
    showGuesses: '⬆️ Guesses',
    hideGuesses: '⬇️ Hide guesses',
    // Round summary overlay
    copyRoundImage: 'Copy the round image',
    share: 'Share',
    copied: 'Copied',
    roundAuthorWas: 'Author was',
    playersGuesses: 'Players guesses',
    meSuffix: '(Me)',
    pts: 'pts',
    pt: 'pt',
    roundMessages: 'Round messages',
    noMessage: 'No message',
    gifLoading: 'Loading GIF…',
    gifAlt: 'GIF',
    imageAlt: 'Image',
    // Game end
    gameEnded: 'Game ended',
    finalRanking: 'Final ranking',
    restart: 'Restart',
    // Footer settings line
    roundsNoun: 'rounds',
    messagesPerRoundNoun: 'messages/round',
    textsAndGifs: 'texts and GIFs',
    sequentialMessages: 'messages in a row',
    randomMessages: 'random messages',
  },
  fr: {
    // General
    appTitle: 'TerraGuessr',
    continue: 'Continuer',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    createRoom: 'Créer une salle',
    or: 'ou',
    join: 'Rejoindre',
    roomsCodePlaceholder: 'Code salon (6 chiffres)',
    inviteDiscordBot: 'Inviter le bot Discord',
    quit: 'Quitter',
    close: 'Fermer',
    openChat: 'Ouvrir le chat',
    closeChat: 'Fermer le chat',
    connecting: 'Connexion…',
    room: 'Salon',
    scores: 'Scores',
    announcements: 'Annonces',
    chat: 'Chat',
    send: 'Envoyer',
    chat_placeholder: 'Message...',
    logoAlt: 'Logo',
    switchToFrench: 'Passer en français',
    switchToEnglish: 'Passer en anglais',
    // Landing
    landing_subtitle: "Devine l'auteur des messages, affronte tes amis, et grimpe au classement.",
    landing_placeholder: 'Entrez un pseudo',
    landing_error_required: 'Le pseudo est obligatoire (max 16 caractères).',
    landing_toRooms_title: 'Entrez un pseudo pour continuer',
    landing_toRooms_btn: 'Voir les salons',
    // Home
    home_welcome: 'Bienvenue sur TerraGuessr',
    home_choose_nickname: 'Choisis un pseudo pour commencer',
    home_nickname_placeholder: 'Pseudo',
    // ServerList
    servers_join_or_create: 'Rejoindre ou créer un salon',
    servers_launch_with_bot: 'Lancer une partie avec le bot Discord',
    servers_step_invite: 'Invitez le bot sur votre serveur Discord.',
    servers_step_command: 'Dans le bon salon, exécutez la commande ci‑dessous.',
    servers_copy_title: 'Copiez puis collez cette commande dans Discord',
    servers_edit_nickname: 'Modifier le pseudo',
    // Game header
    round: 'Manche',
    phase: 'Phase',
  phase_thinking: 'Réflexion',
  phase_result: 'Résultat',
  phase_transition: 'Transition',
  phase_ended: 'Terminé',
    settings: 'Paramètres',
    importBeforeStart: 'Importer dump.csv avant de démarrer',
    importOk: '✓ Import OK',
    roundsLabel: 'Rounds',
    messagesPerRoundLabel: 'Messages/round',
    minMessageLengthLabel: 'Pav-o-meter',
    thinkingTimeLabel: 'Temps réflexion (s/message)',
    onlyGifs: 'Uniquement Gifs',
    beta: 'Bêta',
    messagesInARow: 'Messages à la suite',
    configureThenStart: 'Configurez les paramètres puis utilisez le bouton en bas pour démarrer',
  // Modes / Tabs
  modes: 'Modes',
  configuration: 'Configuration',
  selectModeFirst: 'Sélectionnez un mode d\'abord',
  mode_classic_name: 'Classique',
  mode_classic_desc: 'Devinez l\'auteur à partir de messages révélés progressivement.',
  mode_mashup_name: 'À qui le son ?',
  mode_mashup_desc: 'Devinez qui a fait l\'extrait audio.',
  mode_chrono_name: 'Chrono',
  mode_chrono_desc: 'Devinez quand un message a été posté, sur une frise.',
  mode_blindtest_name: 'Blind Test',
  mode_blindtest_desc: 'Devinez de quel mashup vient l\'extrait.',
  source_messages: 'Messages',
  source_mashups: 'Mashups',
  source_creation: 'Création',
  mode_atelier_name: 'Art Battle',
  mode_atelier_desc: 'Dessine le thème, puis tout le monde note à l’aveugle. Reveal du dernier au premier.',
  atelierPrompt: 'À dessiner', atelierSubmit: 'Valider mon dessin', atelierWaitOthers: 'En attente des autres...',
  atelierRateHint: 'Note les créations', atelierNoOther: 'Rien à noter.', atelierResults: 'Résultats',
  atelierReadyHint: 'Prêt à créer !', atelierCreateTime: 'Temps de dessin', atelierRateTime: 'Temps de notation',
  atelierConfigHint: 'Chacun dessine le thème, puis note à l’aveugle. Reveal du dernier au premier.',
  mode_studio_name: 'Studio',
  mode_studio_desc: 'Recrée le mashup qu’on te donne : enregistre des pistes superposées, puis tout le monde note à l’aveugle.',
  studioPrompt: 'À composer', studioSubmit: 'Valider ma création',
  studioHint: 'Mets un casque, écoute le mashup, puis empile tes pistes.',
  studioRecreate: 'Recrée ce mashup', studioReference: 'Référence (le mashup)',
  studioAddTrack: 'Nouvelle piste', studioCountin: '… prépare-toi (1er passage)', studioRecording: '🔴 Enregistrement…',
  studioSubmitted: 'Création envoyée, en attente des autres...', studioMicDenied: 'Micro refusé ou indisponible.',
  studioDecodeErr: 'Échec du décodage de la prise.', studioRateTitle: 'Note les créations', studioCreation: 'Création',
  studioResults: 'Résultats', studioLoopLabel: 'Longueur de boucle', studioCreateLabel: 'Temps de création',
  studioRateLabel: 'Temps de notation', studioSameMashup: 'Le même mashup pour tout le monde',
  studioMetro: 'Métronome', studioPlayAll: 'Tout écouter', play: 'Lecture',
  studioEmptyHint: 'Place le curseur, puis ⏺ pour enregistrer',
  studioBadExtract: 'Mon extrait ne convient pas',
  studioRecTrack: 'Enregistrer une piste', studioStopRec: 'Arrêter l’enregistrement',
  studioMonitor: 'Écouter', studioMonMashup: 'Mashup', studioMonTracks: 'Pistes', studioMonNone: 'Rien',
  studioRecord: 'Enregistrer', studioPreview: 'Écouter', studioStop: 'Stop', studioUndo: 'Annuler',
  studioBusy: '...', studioFull: 'Max atteint', studioLayer: 'Couche', studioVoices: 'voix',
  studioCountin: 'Prépare-toi...', studioRecording: '🔴 Chante !',
  studioMicErr: 'Micro indisponible (autorise le micro).',
  studioNoSupport: "Ton navigateur ne supporte pas l'enregistrement audio.",
  studioConfigHint: 'Chacun compose une prod (beat + voix), puis note à l’aveugle. Reveal du dernier au premier.',
  studioCreateTime: 'Temps de studio',
  mode_discussion_name: 'Bluff',
  mode_discussion_desc: 'Un vrai message s’affiche. Invente une fausse réponse, puis retrouve la vraie parmi les bluffs.',
  discussionContext: 'La discussion', discussionWrite: 'Ta fausse réponse', discussionWritePlaceholder: 'Invente sa réponse...',
  discussionReplyAs: 'Réponds comme', discussionWhichReal: 'Quelle est la vraie réponse de',
  discussionSubmitLie: 'Valider mon bluff', discussionWaitLies: 'En attente des autres...',
  discussionVoteHint: 'Laquelle est la VRAIE réponse ?', discussionVoted: 'Voté !', discussionYourLie: 'ton bluff',
  discussionReal: 'Vraie réponse', discussionResults: 'Résultats', discussionFound: 'a trouvé', discussionFooled: 'piégé',
  discussionWriteTime: 'Temps d’écriture', discussionVoteTime: 'Temps de vote',
  discussionConfigHint: 'Chacun écrit une fausse réponse, puis doit retrouver la vraie. Trouver : +2. Piéger : +1.',
  chronoThinkLabel: 'Temps pour deviner',
  chronoDragHint: 'Glisse le curseur pour placer ta date, puis valide',
  chronoWaiting: 'En attente des autres joueurs...',
  mode_firstgif_name: 'Premier GIF',
  mode_firstgif_desc: 'Quand cet auteur a-t-il envoyé ce GIF pour la première fois ? Place-le sur la frise.',
  mode_events_name: 'Frise',
  mode_events_desc: 'Cinq messages marquants d’un même auteur : remets-les dans l’ordre chronologique.',
  eventsHint: 'Classe du plus ancien (haut) au plus récent (bas)',
  eventsOldest: 'Plus ancien', eventsNewest: 'Plus récent',
  eventsSubmit: 'Valider mon ordre', eventsWaiting: 'En attente des autres...',
  eventsResults: 'Ordre correct', eventsYourScore: 'Ton score',
  eventsTime: 'Temps de classement',
  eventsConfigHint: 'Détecte les messages marquants (bonnes/mauvaises nouvelles) d’un auteur ; les joueurs les remettent dans l’ordre.',
  mode_coverDraw_name: 'Cover', mode_coverDraw_desc: 'Dessine une pochette pour le mashup sur lequel tu tombes, puis tout le monde devine.',
  coverSpinning: 'La roue tourne...', coverYourMashup: 'Ton mashup', coverDrawFor: 'Dessine la pochette de',
  coverSubmit: 'Valider ma cover', coverSubmitted: 'Cover envoyée, en attente des autres...',
  coverYours: 'Ta cover ! Les autres devinent...', coverGuessed: 'Réponse envoyée',
  coverGuessPlaceholder: 'Quel mashup ? (recherche)', coverUpvote: 'Belle cover', coverOfficial: 'Cover officielle !',
  coverBy: 'Par', coverFound: 'Trouvé par', coverNobody: 'Personne n’a trouvé', coverDrawTime: 'Temps de dessin',
  share: 'Partager', linkCopied: 'Copié !', shareHint: 'Scanne, ou clique pour copier le lien',
  privacy: 'Confidentialité', terms: 'Conditions',
  tabProfile: 'Profil',
  settingsTitle: 'Paramètres', languageLabel: 'Langue',
  eloAdminTitle: 'Gestion ELO', eloAdminSearch: 'Rechercher un joueur...', eloAdminSet: 'OK',
  mode_whoisit_name: "C'est qui ?",
  mode_whoisit_desc: 'Un prénom est caché dans un message et les auteurs sont anonymisés. Retrouve le prénom.',
  whoHint: 'Quel est le prénom caché ?', whoPlaceholder: 'Tape le prénom...',
  whoSubmit: 'Deviner', whoWaiting: 'En attente des autres...',
  whoAnswer: 'C’était', whoCorrect: 'Trouvé !', whoWrong: 'Raté',
  whoTime: 'Temps pour deviner',
  whoConfigHint: 'Un prénom est censuré, les auteurs anonymisés. Une orthographe proche est acceptée.',
  whoManageNames: 'Gérer les prénoms', whoNamesHint: 'Un prénom par ligne. Les prénoms détectés sont pré-remplis : complète ou retire ceux qui ne conviennent pas.',
  whoNamesCount: 'prénoms', whoNamesReset: 'Réinitialiser (détectés)', save: 'Enregistrer',
  chronoLock: 'Valider',
  chronoActualDate: 'Date réelle',
  chronoYourGuess: 'Ton guess',
  mashupTitleHint: 'Quel mashup est-ce ?',
  mashupSearchPlaceholder: 'Rechercher un mashup...',
  mashupNoResult: 'Aucun résultat',
  mashupWaitReveal: 'En attente du reveal...',
  blindtestAttemptsLabel: 'Essais',
  drawEnableLabel: 'Zone de dessin partagée',
  drawTab: 'Dessin',
  drawPen: 'Stylo', drawEraser: 'Gomme', drawColor: 'Couleur',
  drawExport: 'Exporter', drawCopied: 'Copié !', drawCopyErr: 'Échec',
  drawTitle: 'Le chef-d’œuvre collectif',
  drawClearVote: 'Vider', drawClearVoteHint: 'Voter pour vider (51%)',
  adminTab: 'Admin', macTitle: 'Accès aux modes', macAdmins: 'Admins', macPlayers: 'Joueurs',
  macHint: 'Toi (owner) as toujours accès à tous les modes. Mise à jour en temps réel.',
  clipDurationLabel: 'Durée de l\'extrait',
  extractionPeriodLabel: 'Position de l\'extrait',
  extractionStart: 'Début',
  extractionMiddle: 'Milieu',
  extractionRandom: 'Aléatoire',
  allowedAuthorsLabel: 'Auteurs autorisés',
  volumeLabel: 'Volume',
  listenAndGuess: 'Écouter',
  mashupLoadError: 'Échec du chargement des auteurs (Terrashup indisponible).',
  mashupAuthorsHint: 'Sélectionne au moins 2 auteurs pour démarrer.',
  mashupReady: 'Prêt à jouer !',
  mashupBy: 'par',
  mashupStarting: 'Ça démarre...',
  // Config split / importing
  messagesSource: 'Source des messages',
  importFromFile: 'Importer un fichier',
  dragOrClick: 'Glissez un fichier ici ou cliquez pour sélectionner',
  remove: 'Retirer',
  replace: 'Remplacer',
  or: 'OU',
  discordConnect: 'Connexion Discord',
  discordNotConnected: 'Aucune source Discord connectée',
  comingSoon: 'Bientôt',
  discordConnected: 'Connecté en tant que',
  selectChannels: 'Sélectionner les salons',
  selectGuilds: 'Sélectionner les serveurs',
  noGuildsFound: 'Aucun serveur trouvé',
  guildOwner: 'Propriétaire',
  selectMessagesDiscord: 'Sélectionner des messages Discord',
  channelsFor: 'Salons pour',
  selected: 'sélectionnés',
  refresh: 'Rafraîchir',
  noChannels: 'Aucun salon',
  channelSelectionHint: 'Sélectionnez jusqu’à 5 salons textuels au total.',
  selectedChannels: 'Salons sélectionnés',
  selectAuthors: 'Sélectionner les auteurs',
  authorsFromChannels: 'Auteurs trouvés dans les salons sélectionnés',
  noAuthorsFound: 'Aucun auteur trouvé',
  authorSelectionHint: 'Sélectionnez entre 2 et 10 auteurs.',
  next: 'Suivant',
  back: 'Retour',
  noAccessibleServers: 'Aucun serveur accessible',
  noAccessServer: 'Le bot ne peut pas accéder à ce serveur',
  emptyServerNoChannels: 'Aucun salon textuel lisible',
  inviteBot: 'Inviter le bot',
  inviteBotExplain: 'Invitez le bot sur le serveur puis rouvrez cette fenêtre.',
  parameters: 'Paramètres',
    // Game / Lobby CTA & misc
    startGame: 'Démarrer la partie',
    importCsvHint: 'Importez un CSV pour pouvoir démarrer',
    datasetReady: 'Dataset prêt',
    pleaseImportCsvBeforeStart: 'Veuillez importer un CSV avant de démarrer.',
    protectedLink: 'Accès via lien protégé',
    confirmQuit: 'Quitter la partie ?',
    // GuessZone
    chooseAuthorHint: "Choisissez l'auteur (liste dynamique selon les messages importés)",
    showGuesses: '⬆️ Guesses',
    hideGuesses: '⬇️ Masquer les guesses',
    // Round summary overlay
    copyRoundImage: "Copier l'image de la manche",
    share: 'Partager',
    copied: 'Copié',
    roundAuthorWas: "L'auteur était",
    playersGuesses: 'Guesses des joueurs',
    meSuffix: '(Moi)',
    pts: 'pts',
    pt: 'pt',
    roundMessages: 'Messages du round',
    noMessage: 'Aucun message',
    gifLoading: 'Chargement du GIF…',
    gifAlt: 'GIF',
    imageAlt: 'Image',
    // Game end
    gameEnded: 'Partie terminée',
    finalRanking: 'Classement final',
    restart: 'Relancer',
    // Footer settings line
    roundsNoun: 'manches',
    messagesPerRoundNoun: 'messages/manche',
    textsAndGifs: 'textes et GIFs',
    sequentialMessages: 'messages à la suite',
    randomMessages: 'messages aléatoires',
  }
};
